<template>
  <div class="card tabcontentcustom">
    <v-row justify="center" align="center">
      <v-col cols="12" md="8" sm="12">
        <v-sheet
          elevation="0"
          class="px-5 py-2 text-center tabcontentcustomouter"
          rounded
        >
          <div class="tabcontentcustom-top">
            <nfl-team-table
              :teamData="schedule"
              :homeLogo="homeLogo"
              :oppLogo="oppLogo"
              :sportsType="sportsType"
            />
          </div>
        </v-sheet>
      </v-col>
      <v-col cols="12" md="12" sm="12">
        <v-sheet
          elevation="0"
          class="px-5 py-2 tabcontentcustom-bottom-outer text-center"
          rounded
        >
          <!--team data table -->
          <div class="tabcontentcustom-bottom">
            <v-data-table
              dense
              :headers="topPlayerHeaders"
              :items="computedTopPlayers"
              :items-per-page="teams.length"
              :item-key="teams._id"
              class="elevation-1"
              hide-default-footer
              sort-desc
              sort-by="DraftKingsProjection"
              mobile-breakpoint="0"
            >
              <!-- s.no -->
              <template v-slot:item._id="{ index }">
                <p class="body-2">{{ index + 1 }}</p>
              </template>
              <!-- s.no -->

              <!-- player name -->
              <template v-slot:item.Name="{ item }">
                <router-link
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  {{ item.Name }}
                </router-link>
              </template>
              <!-- player name ends -->
              <template v-slot:item.status="{ item }">
                <status-indicator :status="item.status" pulse class="ml-2" />
              </template>

              <!--status  -->
              <template v-slot:item.InjuryStatus="{ item }">
                <!-- Blue dot - 'active',
                green dot - 'positive',
                yellow dot -'intermediary'
                red dot - 'negative' -->

                <v-row>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-show="item.InjuryStatus == null"
                        v-on="on"
                        v-bind="attrs"
                      >
                        <status-indicator status="positive" pulse />
                      </v-col>
                    </template>
                    <span>Healthy</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-show="item.InjuryStatus == 'Out'"
                        v-on="on"
                        v-bind="attrs"
                      >
                        <status-indicator status="negative" pulse />
                      </v-col>
                    </template>
                    <span>Out</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-on="on"
                        v-bind="attrs"
                        v-show="item.InjuryStatus == 'Questionable'"
                      >
                        <status-indicator status="intermediary" pulse />
                      </v-col>
                    </template>
                    <span>Questionable</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-on="on"
                        v-bind="attrs"
                        v-show="item.InjuryStatus == 'Probable'"
                      >
                        <status-indicator status="active" pulse />
                      </v-col>
                    </template>
                    <span>Probable</span>
                  </v-tooltip>
                </v-row>
              </template>
              <!-- status -->

              <!-- FPPG -->
              <template v-slot:item.FPPG="{ item }">
                <p class="caption">{{ item.FPPG >> 0 }}</p>
              </template>
              <!-- FPPG ends -->

              <!-- Projection -->
              <template v-slot:item.DraftKingsProjection="{ item }">
                <div v-if="userState.plantype === 'Free'">
                  <img src="/favicon.ico" height="30" alt="upgrade_logo" />
                </div>

                <div v-else>
                  <p class="caption" v-if="gameOperator == 'DraftKings'">
                    {{ item.DraftKingsProjection }}
                  </p>
                  <p class="caption" v-if="gameOperator == 'FanDuel'">
                    {{ item.FandDualProjection }}
                  </p>
                </div>
              </template>
              <!-- Projection ends -->
            </v-data-table>
          </div>
          <!--team data table ends -->
          <!-- //todo: put route links for view profile & Browse all team players -->
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import NflTeamTable from "./teamTables/teamTableNfl.vue";

export default {
  name: "teamTable",
  components: {
    NflTeamTable,
  },

  props: {
    teams: {
      type: Array,
      default: [],
    },
    schedule: {
      type: Array,
      default: [],
    },
    homeLogo: {
      type: String,
      default: "",
    },
    oppLogo: {
      type: String,
      default: "",
    },
    sportsType: {
      type: String,
      default: "",
    },
  },

  computed: {
    ...mapState("userModule", ["userState"]),

    computedTopPlayers() {
      let newTopPlayer = [];
      newTopPlayer = this.teams.filter((_player) => {
        return (
          _player.DraftKingsProjection !== 0 || _player.FandDualProjection !== 0
        );
      });
      return newTopPlayer;
    },
  },

  methods: {
    negToPositive(value) {
      if (value) {
        let negNum = parseInt(value);
        let newNum = Math.abs(negNum);
        return `${newNum}`;
      }
    },
  },

  data: () => ({
    topPlayerHeaders: [
      {
        text: "Position",
        value: "DraftKingsPosition",
        sortable: false,
      },
      { text: "Player", value: "Name" },
      { text: "Status", value: "InjuryStatus" },
      { text: "Projection", value: "DraftKingsProjection" },
      { text: "Salary($)", value: "DraftKingsSalary" },
      { text: "FPPG", value: "FPPG" },
      // { text: "LineUp", value: "lineup" },
    ],
    // isHide: true,
    gameOperator: localStorage.getItem("gameOperator"),
  }),
};
</script>

<style scoped>
@media (max-width: 415px) {
  .team-a {
    margin-right: 70px;
  }

  .team-b {
    margin-left: 70px;
  }
}
</style>
